import { decodeJwtPayload, getAuthToken } from 'setup/authTokenStorage'

let ownerToken: string | null = null
let ownerValue = ''

/**
 * `userId:projectName` of the signed-in account. The broker caches key their contents by it: logging out and
 * back in as another account doesn't reload the tab, so one account's brokers must never be served to another.
 * Memoized on the token, since consumers call it on every render.
 */
export function currentBrokerCacheOwner(): string {
    const token = getAuthToken() ?? ''
    if (token !== ownerToken) {
        const payload = token ? decodeJwtPayload(token) : undefined
        ownerToken = token
        ownerValue = `${payload?.userId ?? ''}:${payload?.projectName ?? ''}`
    }
    return ownerValue
}
